import UploadedDocumentsList from '@Components/DocumentUploadForm/UploadedDocumentsList'
import React, { RefObject } from 'react'
import { UnifiedDocument } from '@Entities/document/document-to-upload'
import Pluralize from 'pluralize'
import './index.scss'

interface FilesPreviewProps {
    uploadedFiles: UnifiedDocument[]
    filesWereUploaded: boolean
    onDescriptionChange?: (document: UnifiedDocument, description: string, index: number) => void
    descriptionHelpText?: string
    onRemove: (document: UnifiedDocument, index: number) => void
    hideConfirmationText?: boolean
    browseFilePickerRef: RefObject<HTMLInputElement | null>
    emptyState?: React.ReactNode
}

const FilesPreview = (props: FilesPreviewProps) => {
    const {
        uploadedFiles,
        onDescriptionChange,
        onRemove,
        filesWereUploaded,
        hideConfirmationText,
        browseFilePickerRef,
        descriptionHelpText,
        emptyState,
    } = props
    return (
        <>
            <div className="files-preview">
                {uploadedFiles.length === 0 ? (
                    (emptyState ?? <p>No files currently selected for upload</p>)
                ) : (
                    <UploadedDocumentsList
                        uploadedFiles={uploadedFiles}
                        onDescriptionChange={onDescriptionChange}
                        descriptionHelpText={descriptionHelpText}
                        onRemove={onRemove}
                        browseFilePickerRef={browseFilePickerRef}
                    />
                )}
            </div>
            {filesWereUploaded && !hideConfirmationText && (
                <b className="files-uploaded-confirmation-text">
                    Your {Pluralize('file', uploadedFiles.length)} {Pluralize('was', uploadedFiles.length)} successfully
                    uploaded!
                </b>
            )}
        </>
    )
}
export default FilesPreview
